// extracted by mini-css-extract-plugin
export default {"contGrafico":"VentasPorSemanaGrafico_contGrafico__1lxwd","graph":"VentasPorSemanaGrafico_graph__pBPMQ"};